module.exports = __webpack_public_path__ + "img/logo2.3dd89f5b.png";